import React, { useMemo } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useQueryState } from 'nuqs'
import { useTranslation } from 'react-i18next'

import { Alert, AlertTitle } from '@/shared/components/ui/alert'
import { Button } from '@/shared/components/ui/button'
import { ampli } from '@/shared/lib/ampli'

export default function ReecentlyFilter() {
	const { t } = useTranslation()

	const recentlyFilters = useMemo(
		() => localStorage.getItem('recently_products_filter'),
		[]
	)
	const [filters] = useQueryState('qf')
	const navigate = useNavigate()
	if (!recentlyFilters || filters === recentlyFilters) return null
	const applyRecentlyFilter = () => {
		ampli.tableApplyLatestFilter()
		navigate({ to: `?qf=${recentlyFilters}` })
	}

	return (
		<Alert variant='neutral'>
			<AlertTitle>{t('recently_filter_available')}</AlertTitle>
			<Button
				size='sm'
				variant='outline'
				tabIndex={-1}
				className='absolute top-2.5 right-3 h-6 shadow-none'
				onClick={applyRecentlyFilter}
			>
				{t('recently_filter_apply')}
			</Button>
		</Alert>
	)
}
